<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-08-26 11:39:06
 * @FilePath: \mrc-ess-fronted\src\Page\Other\Roster\components\printLoading.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-15 11:59:29
-->
<template>
  <normalDialog
    :dialog="isLoading || show"
    width="400"
    :title="''"
    maxWidth="600"
    pad="3"
    color="white"
    @close="closeDialog"
  >
    <template v-slot:content>
      <v-container fluid class="d-flex flex-column align-center">
        <v-row
          class="fill-height max-width"
          align-content="center"
          justify="center"
        >
          <v-col cols="12">
            <v-progress-linear
              color="primary"
              rounded
              :value="value"
              striped
              height="8"
            ></v-progress-linear>
          </v-col>
          <v-col class="text-subtitle-1 text-center" cols="12">
            {{
              show
                ? $t("message_essweb_system_tips_loadingLabel")
                : $t("message_essweb_system_operation_export_exportOutLabel") +
                  "..."
            }}
          </v-col>
        </v-row>
      </v-container>
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "printLoading",
  props: {
    show: { default: false, type: Boolean },
  },
  computed: {
    ...mapGetters(["isLoading"]),
  },
  watch: {
    show(val) {
      const that = this;
      if (val) {
        this.value = 0;
        this.inter = setInterval(() => {
          if (that.value < 99) that.value = that.value + 5;
        }, 1000);
      } else {
        if (that.inter) clearInterval(this.inter);
        this.value = 0;
      }
    },
    isLoading(val) {
      const that = this;
      if (val) {
        this.value = 0;
        this.inter = setInterval(() => {
          if (that.value < 99) that.value = that.value + 5;
        }, 1000);
      } else {
        if (that.inter) clearInterval(this.inter);
        this.value = 0;
      }
    },
  },
  data() {
    return {
      inter: null,
      value: 0,
    };
  },
  mounted() {},
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
  },
};
</script>